
import get from 'lodash/get';
import { OVERLAY_OVER_NAVBAR_CLASS } from '~/constants/global';

const MODAL_CLASS_NAMES = 'modal show d-block';
const REMOVE_BODY_MODAL_CLASS_TIMEOUT = 500;

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    wrapperClass: {
      type: String,
      default: '',
    },
    // Used to customize the header content in the modal
    header: {
      type: Boolean,
      default: false,
    },
    useLightHeaderButton: {
      type: Boolean,
      default: false,
    },

    /**
     * Keep the class added to the body element (OVERLAY_OVER_NAVBAR_CLASS).
     * Useful if you need to open another modal immediately after closing
     * a previous one.
     */
    keepBodyModalClass: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      modalClassNames: [MODAL_CLASS_NAMES, this.wrapperClass],
      mouseDownOutside: false,
    };
  },

  computed: {
    closeButtonClass() {
      return `close ${this.useLightHeaderButton ? 'light' : ''}`;
    },
  },

  watch: {
    async isVisible(newValue) {
      if (newValue) {
        document.body.classList.add(OVERLAY_OVER_NAVBAR_CLASS);
      } else if (!this.keepBodyModalClass) {
        // Remove class after the transition has finished
        setTimeout(() => {
          document.body.classList.remove(OVERLAY_OVER_NAVBAR_CLASS);
        }, REMOVE_BODY_MODAL_CLASS_TIMEOUT);
      }
    },
  },

  methods: {
    closeModal() {
      this.mouseDownOutside = false;
      this.$emit('onClose');
    },
    handleModalMouseUp(event) {
      /**
       * The .modal class has greater z-index value than the .modal-backdrop one,
       * which is intended. Therefore when clicking "outside" the modal we are actually
       * clicking on the .modal class. This piece of code make sure that we only emit
       * the onClose event when clicking outside of the modal body which means clicking
       * on the .modal class itslef and not their inner elements.
      */
      const fullClassNames = this.modalClassNames.join(' ');
      if (get(event, 'target.className', null) === fullClassNames.trim()
        && this.mouseDownOutside) {
        this.closeModal();
      } else {
        this.mouseDownOutside = false;
      }
    },
    handleModalKeyDown(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        this.closeModal();
      }
    },
    handleModalMouseDown(event) {
      /**
       * Need to validate that the mouse down even happened outside of the modal
       * Only close modal if full even happened outside. Mouse down and then mouse up
      */
      const fullClassNames = this.modalClassNames.join(' ');
      if (get(event, 'target.className', null) === fullClassNames.trim()) {
        this.mouseDownOutside = true;
      }
    },
  },
};
